<script>
  import 'vue-strap/dist/vue-strap-lang';
  import { datepicker, checkbox } from 'vue-strap';
  
  export default {
    components: { checkbox, datepicker },
    props: {
      itemSolicitacao: {
        required: true
      },
      manterObservacao: {
        default: true,
        type: Boolean,
      },
      produtos: {
        required: true
      },
      tiposProdutos: {
        required: true
      },
    },
    data() {
      return {
        configuracao: this.$storage.configuracao()
      }
    },
    computed: {
      observacaoItemCompraContador: function() {
        let quantidadeCaracteres = this.itemSolicitacao.observacaoItemCompra ? 
            this.itemSolicitacao.observacaoItemCompra.length : 0;

        return 500 - quantidadeCaracteres;
      }
    },
    methods: {
      validar() {
        return this.$validator.validateAll();
      }
    },
    mounted() {
      this.$nextTick(() => {
        $('.datepicker input').attr('readonly', '');
      });
    }
  }
</script>

<template>
    <div>
        <div class="row" v-if="configuracao.obrigatorioSelecionarProduto">
            <div class="col-md-12">
                <div class="form-group required" :class="{'has-error': errors.has('tipoProduto')}">
                    <label class="control-label" for="tipoProduto">Tipo de produto</label>

                    <select class="form-control"
                            id="tipoProduto"
                            v-model="itemSolicitacao.idTipoProduto"
                            data-vv-name="tipoProduto"
                            data-vv-as="tipo de produto"
                            v-validate="'required'">
                        <option value="">Selecione...</option>
                        <option :value="tipoProduto.idTipoProduto"
                                v-for="tipoProduto in tiposProdutos">
                            {{ tipoProduto.nomeTipoProduto }}
                        </option>
                    </select>

                    <p class="text-danger" v-show="errors.has('tipoProduto')">{{ errors.first('tipoProduto') }}</p>
                </div>
            </div>
        </div>

        <div class="row" v-if="configuracao.obrigatorioSelecionarProduto">
            <div class="col-md-12">
                <div class="form-group required" :class="{'has-error': errors.has('produto')}">
                    <label class="control-label" for="produto">Produto</label>

                    <select class="form-control"
                            id="produto"
                            v-model="itemSolicitacao.idProduto"
                            data-vv-name="produto"
                            data-vv-as="produto"
                            v-validate="'required'">
                        <option value="">Selecione...</option>
                        <option :value="produto.idProduto"
                                v-for="produto in produtos">
                            {{ produto.nome }}
                        </option>
                    </select>

                    <p class="text-danger" v-show="errors.has('produto')">{{ errors.first('produto') }}</p>
                </div>
            </div>
        </div>

        <div class="row">
            <div :class="[configuracao.utilizarValorEstimado ? 'col-xs-6' : 'col-xs-12']">
                <div class="form-group required" :class="{'has-error': errors.has('quantidade')}">
                    <label class="control-label" for="quantidade">Quantidade</label>

                    <input type="text"
                           class="form-control text-right"
                           id="quantidade"
                           v-model="itemSolicitacao.quantidade"
                           data-vv-name="quantidade"
                           v-validate="'required|not_zero'"
                           v-mascara="'moeda'">

                    <p class="text-danger" v-show="errors.has('quantidade')">{{ errors.first('quantidade') }}</p>
                </div>
            </div>

            <div class="col-xs-6" v-if="configuracao.utilizarValorEstimado">
                <div class="form-group required" :class="{'has-error': errors.has('valorEstimado')}">
                    <label class="control-label" for="valor-estimado">Valor unitário estimado (R$)</label>

                    <input type="text"
                           class="form-control text-right"
                           id="valor-estimado"
                           v-model="itemSolicitacao.valorEstimado"
                           data-vv-name="valorEstimado"
                           v-validate="'required|not_zero'"
                           data-vv-as="valor estimado"
                           v-mascara="'moeda'">

                    <p class="text-danger" v-show="errors.has('valorEstimado')">{{ errors.first('valorEstimado') }}</p>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-xs-12">
                <div class="form-group required" :class="{'has-error': errors.has('descricaoMaterial')}">
                    <label class="control-label" for="descricao-material">Descrição do material/serviço</label>

                    <textarea class="form-control"
                              id="descricao-material"
                              v-model="itemSolicitacao.descricao"
                              v-validate="'required'"
                              data-vv-name="descricaoMaterial"
                              data-vv-as="descrição do material/serviço">
          </textarea>

                    <p class="text-danger" v-show="errors.has('descricaoMaterial')">{{ errors.first('descricaoMaterial') }}</p>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-xs-12">
                <div class="form-group" :class="{'has-error': errors.has('nomeMotorista'), 'required': configuracao.solCompraObrigatorioMotoristaLocacao}">
                    <label class="control-label" for="nome-motorista">Nome do motorista</label>

                    <input type="text"
                           class="form-control"
                           id="nome-motorista"
                           v-model="itemSolicitacao.nomeMotorista"
                           v-validate="`${configuracao.solCompraObrigatorioMotoristaLocacao ? 'required' : ''}`"
                           data-vv-name="nomeMotorista"
                           data-vv-as="nome do motorista"
                           maxlength="100">

                    <p class="text-danger" v-show="errors.has('nomeMotorista')">{{ errors.first('nomeMotorista') }}</p>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-sm-4">
                <div class="form-group" :class="{'has-error': errors.has('cnh'), 'required': configuracao.solCompraObrigatorioMotoristaLocacao}">
                    <label class="control-label" for="cnh">CNH</label>

                    <input type="text"
                           class="form-control"
                           id="cnh"
                           v-model="itemSolicitacao.cnh"
                           v-validate="`${configuracao.solCompraObrigatorioMotoristaLocacao ? 'required' : ''}`"
                           data-vv-name="cnh"
                           maxlength="30">

                    <p class="text-danger" v-show="errors.has('cnh')">{{ errors.first('cnh') }}</p>
                </div>
            </div>

            <div class="col-sm-4">
                <div class="form-group" :class="{'has-error': errors.has('validadeCnh'), 'required': configuracao.solCompraObrigatorioMotoristaLocacao}">
                    <label class="control-label" for="validade-cnh">Validade CNH</label>

                    <input type="text"
                           class="form-control"
                           id="validade-cnh"
                           v-model="itemSolicitacao.validadeCnh"
                           v-validate="`${configuracao.solCompraObrigatorioMotoristaLocacao ? 'required|date_format:DD/MM/YYYY' : 'date_format:DD/MM/YYYY'}`"
                           data-vv-name="validadeCnh"
                           data-vv-as="validade cnh"
                           placeholder="    /    /"
                           v-mascara="'data'">

                    <p class="text-danger" v-show="errors.has('validadeCnh')">{{ errors.first('validadeCnh') }}</p>
                </div>
            </div>

            <div class="col-sm-4">
                <div class="form-group" :class="{'has-error': errors.has('dataNascimento'), 'required': configuracao.solCompraObrigatorioMotoristaLocacao}">
                    <label class="control-label" for="data-nascimento">Data de nascimento</label>

                    <input type="text"
                           class="form-control"
                           id="data-nascimento"
                           v-model="itemSolicitacao.dataNascimento"
                           v-validate="`${configuracao.solCompraObrigatorioMotoristaLocacao ? 'required|date_format:DD/MM/YYYY' : 'date_format:DD/MM/YYYY'}`"
                           data-vv-name="dataNascimento"
                           data-vv-as="data de nascimento"
                           v-mascara="'data'">

                    <p class="text-danger" v-show="errors.has('dataNascimento')">{{ errors.first('dataNascimento') }}</p>
                </div>
            </div>
        </div>

        <div class="row" v-if="configuracao.mostrarPeriodoSolicitacaoCompraItemLocacao">
            <div class="col-md-6">
                <div class="form-group required" :class="{'has-error': errors.has('periodoInicio')}">
                    <label class="control-label" for="periodo-inicio">Período início</label>

                    <datepicker v-model="itemSolicitacao.dataCheckin"
                                format="dd/MM/yyyy"
                                id="periodo-inicio"
                                placeholder="  /  /     "
                                lang="pt-BR"
                                data-vv-name="periodoInicio"
                                data-vv-as="período início"
                                v-validate="'required|date_format:DD/MM/YYYY'">
                    </datepicker>

                    <p class="text-danger" v-show="errors.has('periodoInicio')">{{ errors.first('periodoInicio') }}</p>
                </div>
            </div>

            <div class="col-md-6">
                <div class="form-group required" :class="{'has-error': errors.has('dataCheckout')}">
                    <label class="control-label" for="periodo-fim">Período fim</label>

                    <datepicker v-model="itemSolicitacao.dataCheckout"
                                format="dd/MM/yyyy"
                                id="periodo-fim"
                                placeholder="  /  /     "
                                lang="pt-BR"
                                data-vv-name="dataCheckout"
                                data-vv-as="período fim"
                                v-validate="'required|date_format:DD/MM/YYYY'">
                    </datepicker>

                    <p class="text-danger" v-show="errors.has('dataCheckout')">{{ errors.first('dataCheckout') }}</p>
                </div>
            </div>
        </div>

        <div class="row" v-if="!configuracao.solCompraOcultarObservacoes">
            <div class="col-xs-12">
                <div class="form-group">
                    <div class="checkbox">
                        <checkbox @checked="$emit('update:manterObservacao', !manterObservacao)" :value="manterObservacao" type="primary">
                            Manter observação do item de compra (caso esta solicitação
                            demandar outros itens com a mesma observação)
                        </checkbox>
                    </div>
                </div>
            </div>
        </div>

        <div class="row" v-if="!configuracao.solCompraOcultarObservacoes">
            <div class="col-xs-12">
                <div class="form-group">
                    <label class="control-label" for="observacao-item-compra">Observação do item de compra ({{ observacaoItemCompraContador }})</label>

                    <textarea class="form-control"
                              id="observacao-item-compra"
                              v-model="itemSolicitacao.observacaoItemCompra"
                              maxlength="500">
          </textarea>
                </div>
            </div>
        </div>
    </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-compra/componentes/compartilhado/FormLocacaoDeVeiculos.vue